export const convertToCurrencyString = (value?: number): string => {
  if (!value) {
    return 'N/A';
  }

  return 'Rs: ' + value.toLocaleString(undefined, { minimumFractionDigits: 0 });
};
